var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4941 13.9941C14.8195 13.6686 15.3472 13.6686 15.6726 13.9941L19.4226 17.7441C19.748 18.0695 19.748 18.5972 19.4226 18.9226C19.0972 19.248 18.5695 19.248 18.2441 18.9226L14.4941 15.1726C14.1686 14.8472 14.1686 14.3195 14.4941 13.9941Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.3335 9.16668C1.3335 4.5643 5.06446 0.833344 9.66683 0.833344C14.2692 0.833344 18.0002 4.5643 18.0002 9.16668C18.0002 13.769 14.2692 17.5 9.66683 17.5C5.06446 17.5 1.3335 13.769 1.3335 9.16668ZM9.66683 2.50001C5.98493 2.50001 3.00016 5.48478 3.00016 9.16668C3.00016 12.8486 5.98493 15.8333 9.66683 15.8333C13.3487 15.8333 16.3335 12.8486 16.3335 9.16668C16.3335 5.48478 13.3487 2.50001 9.66683 2.50001Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.743143cc3c89308cb247daa3b86c5e00.svg";
export { ForwardRef as ReactComponent };